export const RECEIVE_POLE_TYPES = 'RECEIVE_POLE_TYPES';
export const GET_POLE_TYPES = 'GET_POLE_TYPES';
export const SET_POLE_TYPE = 'SET_POLE_TYPE';
export const UPDATE_POLE_TYPE = 'UPDATE_POLE_TYPE';
export const DELETE_POLE_TYPE = 'DELETE_POLE_TYPE';
export const FETCH_POLE_TYPES = 'FETCH_POLE_TYPES';
